import type { ReactNode } from 'react';
import { Link } from 'react-router';

/**
 * Role gate for the Administration pages.
 *
 * The old tabbed Settings page hid a tab the viewer couldn't use and, if they
 * reached the URL anyway, silently rendered Profile instead — so a bookmarked or
 * Slack-shared `/settings/team` looked like it had moved. Say plainly that the
 * page exists and needs a role. This is UX only; the API refuses the data either
 * way (RolesGuard + @RequireRole).
 */
export function AdminGate({ allowed, need, children }: { allowed: boolean; need: string; children: ReactNode }) {
  if (allowed) return <>{children}</>;
  return (
    <div className="page">
      <div className="detail-head">
        <h2>Not your access level</h2>
      </div>
      <p className="muted">
        This page is for <strong>{need}</strong>. Your role can&apos;t see it — nothing is broken.
      </p>
      <p className="muted">
        Need it? <Link to="/tasks/new?template=access">Request access</Link> and say which page.
      </p>
    </div>
  );
}
